import React from 'react'
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap'
import { withUserStore } from '../../contexts/UserStore'
import { useNavigate } from 'react-router-dom'

const Pricing = () => {
  const navigate = useNavigate()
  const signup = (edition) => {
    navigate(`/signup?edition=${edition}`)
  }

  const betaStickyNote = () => {
    return (<span className="sticky-note">
      <h2>Free Beta!</h2>
      <p>During the beta period, use Prioritize.Plus completely free! Any Edition!</p>
    </span>)
  }

  return (
    <Container className="text-center">
      <div>
        {betaStickyNote()}
      </div>
      <div className="top100 bottom100">
        <div>
          <div className="pricing-heading z-index-3">
            <span className="times-new-roman header-large">Prioritize.Plus</span><br />
            <span className="header-medium">Priority focused progress</span><br />
            <span
              className="text-primary header-small padding-5 rounded05 mouse-pointer"
              onClick={() => navigate('/feature_comparison')}
            >
              Compare Edition Features
            </span>
          </div>
        </div>

        <div className="">
          <Row className="margin-top">
            <Col xs="12" lg="4" className="margin-top">
              <Card
                className="text-center full-height rounded3 border3 mouse-pointer offwhite z-index-3"
                onClick={() => signup('Personal')}
              >
                <CardBody>
                  <h3>Personal Edition</h3>

                  <span className="dollars">
                    <span className="amount">Free</span><br />
                    <span className="units">single user</span>
                  </span><br />

                  <Button
                    onClick={() => signup('Personal')} className="margin-top margin-bottom" size="lg" outline
                    color="info"
                  >Signup
                  </Button><br /><br />
                  <span className="header-medium">Prioritize Yourself</span>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" lg="4">
              <Card
                className="text-center full-height rounded3 border3 mouse-pointer z-index-3"
                onClick={() => signup('Business')}
              >
                <CardBody>
                  <h3>Business Edition</h3>

                  <span className="dollars">
                    <sup className="sign">$</sup><span className="amount">15</span><br />
                    <span className="units">per user per month</span>
                  </span><br />

                  <Button
                    onClick={() => signup('Business')} className="margin-top margin-bottom" size="lg"
                    color="success"
                  >Try it for free
                  </Button><br /><br />
                  <span className="header-medium">Prioritize Your Business</span>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" lg="4" className="margin-top">
              <Card
                className="text-center full-height rounded3 border3 mouse-pointer offwhite z-index-3"
                onClick={() => signup('Team')}
              >
                <CardBody>
                  <h3>Team Edition</h3>

                  <span className="dollars">
                    <sup className="sign">$</sup><span className="amount">9</span><br />
                    <span className="units">per user per month</span>
                  </span><br />

                  <Button onClick={() => signup('Team')} className="margin-top margin-bottom" size="lg" color="primary">Try
                    it for free
                  </Button><br /><br />
                  <span className="header-medium">Prioritize Your Team</span>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </div>
      </div>
    </Container>
  )
}

export default withUserStore(Pricing)
